import { Button, Modal } from "antd";
import { Title, SubTitle, ContainerBox, ContainerText } from "./styles";

interface ModalContato {
  isModalOpen: boolean; // Tipagem para 'isModalOpen'
  handleFechar: () => void; // Tipagem para 'handleFechar'
  content: {
    recepcaoTelefone: string;
    recepcaoEmail: string;
    conciergeWhatsApp: string;
    conciergeTelefone: string;
    conciergeEmail: string;
    wamLigacao: string;
    wamWhatsApp: string;
    wamEmail: string;
    wamPortal: string;
  };
}

export default function ModalContato({
  isModalOpen,
  handleFechar,
  content,
}: ModalContato) {
  return (
    <>
      <Modal
        // title="Contato"
        open={isModalOpen}
        onCancel={handleFechar}
        footer={null}
      >
        <Title>Recepção</Title>

        <ContainerBox>
          <SubTitle>Telefone:</SubTitle>
          <ContainerText>{content.recepcaoTelefone}</ContainerText>
        </ContainerBox>
        <ContainerBox>
          <SubTitle>E-mail: </SubTitle>
          <ContainerText>{content.recepcaoEmail}</ContainerText>
        </ContainerBox>

        <Title>Concierge (autorização de hospedagens)</Title>
        <ContainerBox>
          <SubTitle>WhatsApp:</SubTitle>
          <ContainerText>{content.conciergeWhatsApp}</ContainerText>
        </ContainerBox>

        <ContainerBox>
          <SubTitle> Telefone:</SubTitle>
          <ContainerText>
            <a href={`tel:${content.recepcaoTelefone}`}>
              {content.recepcaoTelefone}
            </a>
          </ContainerText>
        </ContainerBox>

        <ContainerBox>
          <SubTitle>E-mail:</SubTitle>
          <ContainerText>
            <a href={`mailto:${content.conciergeEmail}`}>
              {content.conciergeEmail}
            </a>
          </ContainerText>
        </ContainerBox>

        <Title>
          Para assuntos contratuais: dados cadastrais, extrato financeiro, IR,
          troca de titularidade, escritura, cancelamento, vendas etc.
        </Title>
        <ContainerBox>
          <SubTitle>WAM Group:</SubTitle>
          <ContainerText> Gestora do Contrato </ContainerText>
        </ContainerBox>

        <ContainerBox>
          <SubTitle>Ligação:</SubTitle>
          <ContainerText>{content.wamLigacao}</ContainerText>
        </ContainerBox>

        <ContainerBox>
          <SubTitle>WhatsApp:</SubTitle>
          <ContainerText> {content.wamWhatsApp}</ContainerText>
        </ContainerBox>

        <ContainerBox>
          <SubTitle>E-mail:</SubTitle>
          <ContainerText> {content.wamEmail}</ContainerText>
        </ContainerBox>

        <ContainerBox>
          <SubTitle>Portal:</SubTitle>
          <ContainerText>
            <a href={content.wamPortal}>{content.wamPortal}</a>
          </ContainerText>
        </ContainerBox>
      </Modal>
    </>
  );
}
